module.exports = __webpack_public_path__ + "img/img-footer-app-flows.e3b2e177.svg";